import { Component, OnInit } from "@angular/core";
import { ThemeService } from "../theme/theme-service.service";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-security-page-sign-up",
  templateUrl: "./security-page-sign-up.component.html",
  styleUrls: ["./security-page-sign-up.component.scss"],
})
export class SecurityPageSignUpComponent implements OnInit {
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public previousLink: string;
  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
  }

  goTo() {
    this.router.navigate(["/home"]);
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
  }
}
